import { z } from 'zod';
import http from 'helpers/requests';

//  Validate phone number and return it in international format if valid

import { parsePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js';
import { FormControlTypes } from 'modules/Common/utils/Utility';
import { V } from 'helpers/validationMessages';

//  Otherwise return null
export function validatePhoneNumber(phoneNumber) {
  if (!phoneNumber) return null;

  try {
    const parsedNumber = parsePhoneNumber(phoneNumber);

    if (parsedNumber) {
      // Check if the number is valid for the given country
      return isValidPhoneNumber(phoneNumber, parsedNumber.country);
    }
  } catch (err) {
    return null;
  }
}
export const ConsultantOperatorInfoFormConfig = [
  {
    header: 'General',
    name: 'general',
    className: '',
    controls: [
      {
        label: 'Name',
        placeholder: '',
        name: 'operatorName',
        className: 'col-span-6',
        type: FormControlTypes.Text,
        validation: z.string().min(1, V.required).max(70, V.maxLength(70)),
      },
      {
        label: 'Corporate Registration Number',
        placeholder: 'e.g. company registry number',
        name: 'corporateRegistrationNumber',
        className: 'col-span-6',
        type: FormControlTypes.Text,
        validation: z.string().optional(),
      },
    ],
  },
  {
    header: 'Address',
    name: 'address',
    className: '',
    controls: [
      {
        label: 'Country',
        placeholder: 'Please enter a country',
        name: 'country',
        className: 'col-span-6',
        type: FormControlTypes.ALLDropdown,
        validation: z.string().min(1, V.required).or(z.number()),
      },
      {
        label: 'City',
        placeholder: '',
        name: 'city',
        className: 'col-span-6',
        type: FormControlTypes.Text,
        validation: z.string().min(1, V.required).max(35, V.maxLength(35)),
      },
    ],
  },
  {
    header: 'Contact Information',
    name: 'contact',
    className: '',
    controls: [
      {
        label: 'Name',
        placeholder: '',
        name: 'contactName',
        className: 'col-span-6',
        type: FormControlTypes.Text,
        validation: z.string().min(1, V.required).max(70, V.maxLength(70)),
      },
      {
        label: 'Email',
        placeholder: '',
        name: 'contactEmail',
        className: 'col-span-6',
        type: FormControlTypes.Text,
        validation: z.string().email().min(1, V.required),
      },
      {
        label: 'Phone',
        placeholder: '',
        name: 'phoneNumber',
        className: 'col-span-6',
        type: FormControlTypes.Phone,
        validation: z
          .string()
          .min(1, V.required)
          .refine((value) => value && validatePhoneNumber(value), {
            message: V.invalidPhone,
          }),
      },
    ],
  },
];
